var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container",
    [
      _vm.$wf.isSmDown
        ? _c("app-section", { staticClass: "login-logo" }, [
            _c("img", { attrs: { src: require("@/assets/img/logo_c.png") } }),
          ])
        : _vm._e(),
      _c(
        "app-section",
        [
          _c("app-error-box", { attrs: { hide: !_vm.showError } }, [
            _vm._v(" " + _vm._s(_vm.activationResult) + " "),
          ]),
        ],
        1
      ),
      !_vm.activationComplete
        ? _c(
            "app-section",
            [
              !_vm.activationResult
                ? _c("p", { staticClass: "sub-welcome" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("in-activation")) + " "),
                  ])
                : _vm._e(),
              _vm.activationResult
                ? _c("w-link", { attrs: { to: "/" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("link-back")) + " "),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _c(
            "app-section",
            { staticClass: "completed" },
            [
              _c("h1", [
                _c(
                  "div",
                  { staticClass: "complete-icon" },
                  [_c("w-fa", { attrs: { icon: ["far", "check-circle"] } })],
                  1
                ),
                _vm._v(" " + _vm._s(_vm.$ct("activation-complete")) + " "),
              ]),
              _c(
                "w-button",
                {
                  staticClass: "mt",
                  attrs: { to: "/login?email=" + _vm.user.Email },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("now-login")) + " ")]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }